// assets
import { IconKey,IconSitemap } from '@tabler/icons';

// constant
const icons = {
  IconKey,
  IconSitemap
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const mapping = {


  id: 'authentication',
  title: 'Mapping',
  type: 'group',
  display_id: 'C',
  icon: icons.IconSitemap,
  children: [
   
    {
      id: 'agentds',
      title: 'Agent - Ds',
      display_id: 13,
      type: 'item',
      url: '/Admin/mapping',
      breadcrumbs: false
    },
    {
      id: 'dstm',
      title: 'DS - TM',
      display_id: 14,
      type: 'item',
      url: '/Admin/ops/mapping/ds_tm',
      breadcrumbs: false
    },
    {
      id: 'dsmds',
      title: 'DS - MDS',
      display_id: 15,
      type: 'item',
      url: '/Admin/ops/mapping/ds_mds',
      breadcrumbs: false
    },
    {
      id: 'tmmds',
      title: 'TM - MDS',
      display_id: 16,
      type: 'item',
      url: '/Admin/ops/mapping/tm_mds',
      breadcrumbs: false
    },
    {
      id: 'tmsh',
      title: 'TM - SH',
      display_id: 17,
      type: 'item',
      url: '/Admin/ops/mapping/tm_sh',
      breadcrumbs: false
    },
    {
      id:'location',
      title:'Location Mapping',
      display_id:55,
      type:'item',
      url:'/Admin/location_mapping'
    },
    {
      id: 'fos_mapping',
      title: 'FOS Mapping',
      type: 'item',
      display_id: 117,
      url: '/Admin/fos_mapping',
      breadcrumbs: false
    },
    // sessionStorage.getItem('UserType') === 'ops' && {
    //   id: 'shrm',
    //   title: 'SH - RM',
    //   type: 'item',
    //   url: '/Admin/ops/mapping/sh_rm',
    //   breadcrumbs: false
    // }



  ].filter(Boolean)

};

export default mapping;
